import { useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getCatalogoCondicao } from '../../../../formularios/core/condicao/catalogo'
import {
  compararVersoesModelo,
  listarVersoesModelo,
  obterVersaoModelo,
} from '../../../core/_requests'

/**
 * Dados da comparação entre versões do modelo da plataforma: a versão do `:id`, as demais
 * versões (opções do "Comparar com") e a comparação. `com` vazio = comparar com a publicada
 * (padrão).
 */
export const useComparacaoModelo = () => {
  const { id } = useParams()
  const idVersao = Number(id)
  const [com, setCom] = useState<number | undefined>(undefined)

  const { data: versao } = useQuery(
    ['protocolos-triagem', 'modelo-versao', idVersao],
    () => obterVersaoModelo(idVersao),
    { enabled: !!idVersao, retry: false }
  )
  const { data: versoes } = useQuery(
    ['protocolos-triagem', 'modelo-versoes'],
    () => listarVersoesModelo(),
    { retry: false }
  )
  const comparacao = useQuery(
    ['protocolos-triagem', 'modelo-comparacao', idVersao, com ?? 'publicada'],
    () => compararVersoesModelo(idVersao, com),
    { enabled: !!idVersao, retry: false }
  )
  const { data: catalogo } = useQuery(['condicao', 'catalogo'], () => getCatalogoCondicao(), {
    retry: false,
    staleTime: 60 * 60 * 1000,
  })

  const outrasVersoes = (versoes ?? []).filter((outra) => outra.id !== idVersao)

  return { idVersao, versao, outrasVersoes, comparacao, catalogo, com, setCom }
}
